"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSelectOverrides = void 0;
var createMuiSelectOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, pxToRem = _a.typography.pxToRem;
    var iconSize = 24;
    return {
        select: {
            "&:focus": {
                borderRadius: undefined,
                backgroundColor: undefined,
            },
        },
        selectMenu: {
            height: "auto",
            minHeight: spacing(12),
            "&[class*='MuiInputBase-inputMarginDense']": {
                minHeight: spacing(8),
            },
        },
        outlined: {
            // MUI uses the same for specificity
            "&&": {
                paddingRight: spacing(8),
            },
            "&[class*='MuiInputBase-inputAdornedEnd']": {
                paddingRight: spacing(16),
            },
        },
        icon: {
            fontSize: pxToRem(iconSize),
            color: palette.text.secondary,
        },
        iconOutlined: {
            // The actual icon size is larger than the space so we have to calculate correct margin
            right: spacing(4) - (iconSize - spacing(4)) / 2,
            "[class*='MuiInputBase-marginDense'] &": {
                right: spacing(2) - (iconSize - spacing(4)) / 2,
            },
        },
    };
};
exports.createMuiSelectOverrides = createMuiSelectOverrides;
//# sourceMappingURL=MuiSelect.js.map